








































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Program } from '@/domain/entities/Program'
import Badge from '@/app/ui/components/Badge/index.vue'
import { Utils } from '@/app/infrastructures/misc/Utils'

@Component({
  components: {
    Badge,
  },
})
export default class ProgramItem extends Vue {
  @Prop() private isGuest!: boolean
  @Prop() private program!: Program

  get computedSaldoPoint(): number | string {
    if (this.program.percentOfTransaction) {
      return `${this.program.percentOfTransaction}%`
    }

    return Utils.currencyDigit(this.program.points || 0)
  }

  get computedMaxAmount(): number | string {
    return `Rp${Utils.currencyDigit(this.program.maxAmountGiven || 0)}`
  }

  get getBudgetUsedAndAmount(): number | string {
    return `Rp${Utils.currencyDigit(this.program.budgetUsed || 0)} / Rp${Utils.currencyDigit(this.program.budgetAmount || 0)}`
  }

  get statusBadgeType(): string {
    if (
      this.program?.status?.toLowerCase() === 'expired'
    ) {
      return 'expire'
    } else if (this.program?.status?.toLowerCase() === 'cancelled') {
      return 'cancelled'
    } else if (
      this.program?.status?.toLowerCase() === 'active' ||
      this.program?.status?.toLowerCase() === 'published'
    ) {
      return 'success'
    } else {
      return 'warning'
    }
  }

  private formatDate(date: string) {
    return Utils.formatTimeZone(Utils.formatDate(date))
  }
}
